import { observable } from "mobx";
import SearchStoreActions from "./actions";

class SearchBarStoreClass extends SearchStoreActions {
  @observable showSearch;
  @observable searchText;
  @observable filters;
}
export default SearchBarStoreClass;



// WEBPACK FOOTER //
// ./src/stores/SearchBarStore/index.js